import React from 'react'

const RoomsContext = React.createContext()

// eslint-disable-next-line react/prop-types
const RoomsProvider = ({ children, value }) => {
  return <RoomsContext.Provider value={value}>{children}</RoomsContext.Provider>
}

export { RoomsContext, RoomsProvider }
